/**
 * Zod schemas + types for the agent trigger assignments API (P2.5-C).
 *
 * Imported by both `apps/portal-api` and `apps/portal-frontend` for
 * end-to-end type safety (ADR-005). This file MUST NOT import Node-only
 * modules — it is bundled into the Workers runtime and the browser.
 */
import { z } from "zod";
/** The three supported SMB trigger types. */
export const TRIGGER_TYPES = ["lead_qualify", "lead_book", "content_draft"];
/**
 * A single trigger assignment row — as returned from GET /api/v1/triggers.
 */
export const TriggerAssignmentSchema = z.object({
    id: z.string().uuid(),
    trigger_type: z.string(),
    agent_id: z.string().uuid(),
    enabled: z.boolean(),
    updated_at: z.string(),
});
/** `GET /api/v1/triggers` response. */
export const TriggerListResponseSchema = z.object({
    items: z.array(TriggerAssignmentSchema),
});
/** `PUT /api/v1/triggers/:type` request body. */
export const UpsertTriggerRequestSchema = z.object({
    agent_id: z.string().uuid().nullable(),
    enabled: z.boolean(),
});
//# sourceMappingURL=agent-triggers.js.map